/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormEvent, ReactNode } from 'react';

import env from '@eneco/common/env';
import { RecaptchaForm } from '@eneco/components/RecaptchaForm/RecaptchaForm';
import { Form } from '@eneco/sparky';
import { FieldValues, SubmitHandler, useFormContext } from 'react-hook-form';

const RECAPTCHA_SITE_KEY = env('RECAPTCHA_SITE_KEY');

type ReCaptchaFormBeProps<T extends FieldValues> = {
  recaptchaRef: any;
  children: ReactNode;
  submitForm: SubmitHandler<T>;
};

export const RecaptchaFormBe = <T extends FieldValues>({
  recaptchaRef,
  children,
  submitForm,
}: ReCaptchaFormBeProps<T>) => {
  const methods = useFormContext<T>();

  if (methods === null) {
    throw new Error(`RecaptchaFormBe must be used within a FormProvider`);
  }

  const { handleSubmit, setValue } = methods;

  const submitHandlerWithoutCaptcha = async (event: FormEvent) => {
    event.preventDefault();
    setValue('recaptchaToken' as any, 'fake-captcha-token' as any);
    return await handleSubmit((data: FieldValues) => submitForm(data as T))();
  };

  if (RECAPTCHA_SITE_KEY) {
    return (
      <RecaptchaForm onSubmit={submitForm} recaptchaRef={recaptchaRef}>
        {children}
      </RecaptchaForm>
    );
  } else {
    return <Form onSubmit={submitHandlerWithoutCaptcha}>{children}</Form>;
  }
};
